export default function SaLayout ({ children }) {

    return (
        <div className='sa'>
            { children }
        </div>
    )
}


